import { useAppContext } from "../../context/AppContext";
import { ScheduleTrans } from "../../utils/translations";
import { hasActiveOnlineClubPass } from "../../utils/communityPassHelpers";

/** Subscribed online club members – private channel */
export const TELEGRAM_ONLINE_CLUB_SUBSCRIBED = "https://t.me/+2bXilpAUGS03MDUy";
/** Without subscription – public invite */
export const TELEGRAM_ONLINE_CLUB_GUEST = "https://t.me/+KpMztbN-sr8xNmMy";

/**
 * Online club community via Telegram.
 * Subscribed users get the members link; others get the public link.
 * Only shown for russian + IL. Pass isOnlineClubContext=false to hide (e.g. studio schedule).
 */
/**
 * @param {string} [wrapClassName] – outer wrapper; use flex-1 when sitting next to WhatsAppSection
 */
export default function TelegramSection({ isOnlineClubContext = true, wrapClassName }) {
  const { language, country, user } = useAppContext();
  const details = ScheduleTrans[language];

  if (!isOnlineClubContext) return null;
  if (language !== "russian" || country !== "IL") return null;

  const outerClass = wrapClassName ?? "w-fit mx-auto";

  const subscribed = hasActiveOnlineClubPass(user);
  const href = subscribed ? TELEGRAM_ONLINE_CLUB_SUBSCRIBED : TELEGRAM_ONLINE_CLUB_GUEST;

  return (
    <div className={outerClass}>
      <div className="bg-sky-50 border-2 border-sky-200 rounded-2xl p-3 flex items-center justify-center max-w-md mx-auto">
        <div className="flex-1">
          <p className="text-sm text-gray-700 mb-2">
            {subscribed ? details.closedClubChat : details.joinClubChat} 📢
          </p>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-sky-500 hover:bg-sky-600 text-white font-semibold text-xs py-2 px-4 rounded-lg transition"
          >
            {details.telegramChannel}
          </a>
        </div>
      </div>
    </div>
  );
}
